import { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import Select from "react-select";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";

import Grid from "@mui/material/Grid";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import dayjs from "dayjs";

import { default as SingleSelect } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import NumericInput from "react-numeric-input";

import TableRowNoResults from "../../components/TableRowNoResults";
import SelectStudentListsDialog from "../../components/faculty/SelectStudentListsDialog";

import { doService } from "../../services/ServiceHelper";

import {
  getScorePeriods,
  getScoreConsequences,
  calculateConsequences,
  getPreviousScores,
  saveScores,
  getMyStudentScores,
  buildScores,
} from "../../services/ScoreService";
import {
  getTeacherUserLists,
  getSchoolStudents,
} from "../../services/UserService";
import { getYYYYMMDD } from "../../services/DateService";
import ProgressCircle from "../ProgressCircle";
import { showError, showToast } from "../ATPDialogs";
import isEmpty from "lodash-es/isEmpty";
import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";
import Alert from "@mui/material/Alert";
import HeaderText from "../HeaderText";
import { Divider } from "@mui/material";
import { useScoreCategories } from "../../hooks/useScoreCategories";
import { ReactComponent as TimerIcon } from "../../icons/Timer24.svg";

const AddQuickScore = ({
  jwt,
  school,
  isDetailedView = true,
  showPrintReceipt = true,
  initialStudents = [],
  initShowDialog = false,
  onOK = null,
}) => {
  const navigate = useNavigate();

  const [_scoreDate, setScoreDate] = useState(dayjs());
  const [_scorePeriods, setScorePeriods] = useState([]);
  const [_students, setStudents] = useState([]);
  const [_consequences, setConsequences] = useState([]);
  const [_scoreValue, setScoreValue] = useState(0);
  const [_comment, setComment] = useState("");

  const [_selectedScoreCategoryId, setSelectedScoreCategoryId] = useState("XX");
  const [_selectedScoreCategoryTardiness, setSelectedScoreCategoryTardiness] =
    useState("N");

  const [_selectedScorePeriod, setSelectedScorePeriod] = useState("");
  const [_selectedScoreGroup] = useState("S");
  const [_selectedStudents, setSelectedStudents] = useState([]);

  const [_previousScores, setPreviousScores] = useState([]);
  const [_consequenceDisabled, setConsequenceDisabled] = useState(true);
  const [_userLists, setUserLists] = useState([]);
  const [_selectedConsequenceEid, setSelectedConsequenceEid] = useState("XX");

  const [_calculatedConsequences, setCalculatedConsequences] = useState([]);
  const [_calculatedConsequenceMap, setCalculatedConsequenceMap] = useState({});

  const [showProgress, setShowProgress] = useState(false);

  const [_dialogStudentListsOpen, setDialogStudentListsOpen] = useState(false);
  const [_dialogPreviousScoresOpen, setDialogPreviousScoresOpen] =
    useState(false);

  const [_dialogConsequenceListOpen, setDialogConsequenceListOpen] =
    useState(false);
  const [_dialogDetailedScoreOpen, setDialogDetailedScoreOpen] =
    useState(initShowDialog);

  const [_receiptUrl, setReceiptUrl] = useState("");
  const [_dialogQuickOpen, setDialogQuickOpen] = useState(false);
  const [_selectedQuickStudents, setSelectedQuickStudents] = useState([]);
  const [_myStudentScores, setMyStudentScores] = useState([]);
  const {
    categories: _scoreCategories,
    scoreCategoryMap: _scoreCategoryMap,
    tardinessCategory,
  } = useScoreCategories(school, jwt);
  const [_selectedScoreCategory, setSelectedScoreCategory] = useState({});
  const [_selectedReasonObj, setSelectedReasonObj] = useState({
    label: "Citizenship",
    value: 438,
  });

  useEffect(() => {
    initStudents();
    initMyStudents();
  }, []);

  useEffect(() => {
    if (_selectedScoreCategoryId === "XX" && tardinessCategory != null) {
      handleChangeScoreCategory({
        target: { value: tardinessCategory.id },
        map: _scoreCategoryMap,
      });
    }
  }, [_scoreCategoryMap, _selectedScoreCategoryId, tardinessCategory]);

  useEffect(() => {
    if (_dialogDetailedScoreOpen !== true || _userLists.length > 0) {
      return;
    }

    initUserLists();
  }, [_dialogDetailedScoreOpen, _userLists.length]);

  useEffect(() => {
    if (_dialogDetailedScoreOpen !== true || _consequences.length > 0) {
      return;
    }

    initConsequences();
  }, [_dialogDetailedScoreOpen, _consequences.length]);

  useEffect(() => {
    if (_dialogDetailedScoreOpen !== true || _scorePeriods.length > 0) {
      return;
    }

    initScorePeriods();
  }, [_dialogDetailedScoreOpen, _scorePeriods.length]);

  const initMyStudents = () => {
    doService(getMyStudentScores(school, jwt), (results) => {
      setMyStudentScores(results.data);
    });
  };

  const initConsequences = () => {
    doService(getScoreConsequences(school, jwt), (results) => {
      const entries = [];
      const map = {};
      entries.push({
        label: "--------",
        value: "XX",
      });
      for (const entry of results.data) {
        entries.push({
          label: entry.name,
          value: entry.eid,
        });
        map["c" + entry.eid] = entry;
      }
      setConsequences(entries);
    });
  };

  const initUserLists = () => {
    doService(getTeacherUserLists(school, jwt), (results) => {
      const entries = [];
      for (const entry of results.data) {
        entries.push({
          label: entry.name,
          value: entry.id,
        });
      }
      setUserLists(entries);
    });
  };

  const initScorePeriods = () => {
    doService(getScorePeriods(school, jwt), (results) => {
      const entries = [];
      for (const entry of results.data) {
        entries.push({
          label: entry.name,
          value: entry.value,
        });
      }
      setScorePeriods(entries);
    });
  };

  const initStudents = () => {
    doService(getSchoolStudents(school, jwt), (results) => {
      const labeledStudents = [];
      const initialStudentsMap = {};
      const selectedStudents = [];

      // store the eid as a key and value
      for (const initialStudent of initialStudents) {
        initialStudentsMap[initialStudent] = initialStudent;
      }

      for (const student of results.data) {
        const entry = {
          value: student.eid,
        };

        if (!isEmpty(student.externalId)) {
          entry.label = `${student.last_name}, ${student.first_name} (${student.externalId})`;
        } else {
          entry.label = `${student.last_name}, ${student.first_name} (${student.grade})`;
        }

        labeledStudents.push(entry);

        // if this student is an initial student then pre-populate
        if (initialStudentsMap[student.eid] != null) {
          selectedStudents.push(entry);
        }
      }
      setStudents(labeledStudents);
      setSelectedStudents(selectedStudents);
    });
  };

  const handleChangeConsequence = (obj) => {
    setSelectedConsequenceEid(obj.value);
  };

  const handleChangeComment = (event) => setComment(event.target.value);

  const handleClickSave = () => {
    doSave(false);
  };

  const doSave = (printPass) => {
    const studentEids = getStudentEids();
    const categoryId = _selectedScoreCategoryId;
    const comment = _comment;
    const commentId = null;
    const period = _selectedScorePeriod;

    if (studentEids.length === 0) {
      showError("Please select at least one student.");
      return;
    }

    if (categoryId === "" || categoryId == null) {
      showError("Please select a Score Category.");
      return;
    }

    if (
      !_consequenceDisabled &&
      _selectedConsequenceEid === "XX" &&
      _selectedScoreCategoryTardiness === "Y"
    ) {
      showError("Please select a Consequence.");
      return;
    }

    // build scores
    const scores = buildScores(
      _selectedScoreCategoryId,
      _selectedConsequenceEid,
      _selectedScoreCategoryTardiness,
      studentEids,
      _calculatedConsequenceMap,
      comment,
      commentId,
      period,
      _scoreValue,
      _selectedReasonObj != null ? _selectedReasonObj.value : null,
    );
    const date = getYYYYMMDD();

    doService(saveScores(school, jwt, date, scores), (results) => {
      const scoreEidArry = results.data;

      //clear values
      setSelectedStudents([]);

      if (printPass) {
        const url = `/#/score/receipt/${scoreEidArry.join(",")}`;
        setReceiptUrl(url);

        setTimeout(function () {
          document.getElementById("rl").click();
        }, 300);
      } else {
        showToast("S", "Score Created!");
      }

      if (onOK) {
        onOK();
      }
    });
  };

  const handleClickSavePrintReceipt = () => {
    doSave(true);
  };

  const handleClickViewAutoConsequences = () => {
    setDialogConsequenceListOpen(true);
  };

  // pull IDs from collected values (it;'s an arry with value attribute)
  const getStudentEids = () => {
    const studentEids = [];

    // pull IDs from collected values (it;'s an arry with value attribute)
    for (let obj of _selectedStudents) {
      studentEids.push(obj.value);
    }
    return studentEids;
  };

  const handleClickPreviousScores = () => {
    const studentEids = getStudentEids();

    // don't pull if no user selected
    if (studentEids.length === 0) {
      return;
    }

    doService(getPreviousScores(school, jwt, studentEids), (results) => {
      const relevantResults = [];

      for (let result of results.data) {
        if (result.scores.length > 0) {
          // flatten results
          for (let score of result.scores) {
            relevantResults.push({
              last_name: result["last_name"],
              first_name: result["first_name"],
              student_eid: result["student_eid"],
              scoreDate: score["scoreDate"],
              categoryName: score["categoryName"],
              scoreValue: score["scoreValue"],
              conName: score["conName"],
              comment: score["comment"],
            });
          }
        }
      }
      setPreviousScores(relevantResults);
      setDialogPreviousScoresOpen(true);
    });
  };

  const handleChangeScoreCategory = (event) => {
    setSelectedScoreCategoryId(event.target.value);

    let scoreCategoryMap = _scoreCategoryMap;
    // if the score category map was passed in then use that instead
    if (event.map) {
      scoreCategoryMap = event.map;
    }

    if (scoreCategoryMap["c" + event.target.value] != null) {
      setSelectedScoreCategoryTardiness(
        scoreCategoryMap["c" + event.target.value].isTardiness,
      );
    }

    // set default score value
    setScoreValue(scoreCategoryMap["c" + event.target.value].defaultScoreValue);
    setCalculatedConsequences([]);
    setCalculatedConsequenceMap({});

    const useAutoConsequence = getUseAutoConsequence(
      event.target.value,
      scoreCategoryMap,
    );
    setSelectedConsequenceEid("XX");

    // alert(event.target.value + ": " + useAutoConsequence);
    if (useAutoConsequence === "Y") {
      // if use auto consequence, disable the drop box and show the calculated table
      setConsequenceDisabled(true);
      initAutoConsequence(
        event.target.value,
        _selectedScorePeriod,
        _selectedStudents,
      );
    } else {
      // if NOT use auto consequence, enable the drop box and hide the calculated table
      setConsequenceDisabled(false);
    }
  };

  const handleChangeScorePeriod = (entry) => {
    setSelectedScorePeriod(entry.value);

    const useAutoConsequence = getUseAutoConsequence(_selectedScoreCategoryId);
    if (useAutoConsequence === "Y" && _selectedScoreCategoryId !== "XX") {
      initAutoConsequence(
        _selectedScoreCategoryId,
        entry.value,
        _selectedStudents,
      );
    }
  };

  const getUseAutoConsequence = (
    selectedScoreCategory,
    scoreCategoryMap = null,
  ) => {
    // use the local one if specified
    if (scoreCategoryMap == null) {
      scoreCategoryMap = _scoreCategoryMap;
    }

    if (scoreCategoryMap["c" + selectedScoreCategory] != null) {
      return scoreCategoryMap["c" + selectedScoreCategory].useAutoConsequence;
    }
    return "N";
  };

  const handleChangeStudents = (value) => {
    setSelectedStudents(value);

    const useAutoConsequence = getUseAutoConsequence(_selectedScoreCategoryId);
    if (useAutoConsequence === "Y" && _selectedScoreCategoryId !== "XX") {
      initAutoConsequence(
        _selectedScoreCategoryId,
        _selectedScorePeriod,
        value,
      );
    }
  };

  const handleStudentListClose = () => {
    setDialogStudentListsOpen(false);
  };

  const handleStudentListOK = (selectedList) => {
    setDialogStudentListsOpen(false);
    setShowProgress(true);
  };

  const initAutoConsequence = (scoreCategoryId, period, selectedStudents) => {
    const studentEids = [];

    // pull IDs from collected values (it;'s an arry with value attribute)
    for (let obj of selectedStudents) {
      studentEids.push(obj.value);
    }

    // don't pull if no user selected
    if (studentEids.length === 0) {
      return;
    }

    setShowProgress(true);
    return doService(
      calculateConsequences(school, jwt, studentEids, scoreCategoryId, period),
      (results) => {
        setCalculatedConsequences(results.data);

        const map = {};
        for (let result of results.data) {
          map[result.studentEid] = result;
        }

        setCalculatedConsequenceMap(map);
        setShowProgress(false);
      },
      null,
      null,
      () => {
        setShowProgress(false);
      },
    );
  };

  const doCalculateConsequences = async (studentEids, period) => {
    let consequenceMap = {};

    setShowProgress(true);
    await doService(
      calculateConsequences(
        school,
        jwt,
        studentEids,
        _selectedScoreCategoryId,
        period,
      ),
      (results) => {
        setCalculatedConsequences(results.data);

        for (let result of results.data) {
          consequenceMap[result.studentEid] = result;
        }

        setCalculatedConsequenceMap(consequenceMap);
        setShowProgress(false);
        return consequenceMap;
      },
      null,
      null,
      () => {
        setShowProgress(false);
      },
    );

    let reasonId = null;
    if (
      _selectedScoreCategory.reasons != null &&
      _selectedScoreCategory.reasons.length > 0
    ) {
      reasonId = _selectedReasonObj != null ? _selectedReasonObj.value : null;
    }

    doQuickSave(studentEids, consequenceMap, reasonId);
  };

  const doQuickSave = (studentEids, consequenceMap, reasonId) => {
    let date = getYYYYMMDD();

    const scores = buildScores(
      _selectedScoreCategoryId,
      _selectedConsequenceEid,
      _selectedScoreCategoryTardiness,
      studentEids,
      consequenceMap,
      "quick save",
      null,
      "0",
      0,
      _selectedReasonObj != null ? _selectedReasonObj.value : null,
    );

    doService(saveScores(school, jwt, date, scores), (results) => {
      //clear values
      setSelectedStudents([]);
      showToast("S", "Score(s) Created!");

      if (onOK) {
        onOK();
      }
    });
  };

  const handleCloseConsequenceList = () => {
    setDialogConsequenceListOpen(false);
  };

  const handleOpenDetailedScoreDialog = () => {
    setDialogDetailedScoreOpen(true);
  };

  const handleCloseDetailedScoreDialog = () => {
    setDialogDetailedScoreOpen(false);
  };

  const handleClosePreviousScores = () => {
    setDialogPreviousScoresOpen(false);
  };

  const handleClickTardyQrCode = () => {
    navigate("/teacher/score/tardy");
  };

  const handleClickTardyKiosk = () => {
    navigate("/teacher/tardy/kiosk");
  };

  const getTardyCategoryId = () => {
    return tardinessCategory != null ? tardinessCategory.id : null;
  };

  const getDressCodeCategoryId = () => {
    for (const cat of _scoreCategories) {
      if (cat.name === "Dress Code") {
        return cat.id;
      }
    }
    return null;
  };

  const handleClickQuickCategory = (category) => {
    setSelectedQuickStudents([]);
    setSelectedScoreCategoryId(category.id);
    setSelectedScoreCategory(category);

    // need to find the tardiness category id
    setDialogQuickOpen(true);
  };

  const handleCloseQuick = () => {
    setDialogQuickOpen(false);
  };

  const handleOKQuick = async () => {
    setDialogQuickOpen(false);

    if (_selectedQuickStudents == null || _selectedQuickStudents.length === 0) {
      alert("Please select 1 or more students.");
      return;
    }

    // get the values from the objects
    const studentEids = [];
    for (const student of _selectedQuickStudents) {
      studentEids.push(student.value);
    }

    return doCalculateConsequences(studentEids, 0);
  };

  const handleChangeQuickStudents = (objs) => {
    setSelectedQuickStudents(objs);
  };

  const handleChangeQuickReason = (obj) => {
    console.log(obj);
    setSelectedReasonObj(obj);
  };

  const renderDetailedScoreContent = () => (
    <>
      <InputLabel sx={{ mt: 1 }}>Select Student(s)</InputLabel>
      <Select
        options={_students}
        onChange={handleChangeStudents}
        isMulti={true}
        value={_selectedStudents}
      />
      <Button
        sx={{ mt: 1 }}
        variant="outlined"
        title="previous scores"
        onClick={handleClickPreviousScores}
      >
        Previous
      </Button>
      <Grid container spacing={1} sx={{ mt: 0.0 }}>
        <Grid item xs={4}>
          <InputLabel>Score Category *</InputLabel>

          <SingleSelect
            fullWidth
            size="small"
            value={_selectedScoreCategoryId}
            onChange={handleChangeScoreCategory}
          >
            <MenuItem key="XX" value="XX">
              -- SELECT --
            </MenuItem>
            {_scoreCategories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </SingleSelect>
        </Grid>

        {_selectedScoreCategoryId === "XX" && <Grid item xs={8}></Grid>}

        {_selectedScoreCategoryId !== "XX" && (
          <>
            {_selectedScoreCategoryTardiness === "N" && (
              <Grid item xs={8}>
                <InputLabel sx={{ mt: 0 }}>Score Value</InputLabel>
                <NumericInput
                  className="numericInput"
                  min={0}
                  max={40}
                  value={_scoreValue}
                  onChange={(value) => {
                    setScoreValue(value);
                  }}
                />
              </Grid>
            )}

            {_selectedScoreCategoryTardiness === "Y" && (
              <Grid item xs={8}>
                <InputLabel sx={{ mt: 0 }}>
                  Consequence
                  {getUseAutoConsequence(_selectedScoreCategoryId) === "Y" && (
                    <> (calculated)</>
                  )}
                  {getUseAutoConsequence(_selectedScoreCategoryId) === "N" && (
                    <> (optional)</>
                  )}
                </InputLabel>
                <Box display="flex" p={0} bgcolor="background.paper">
                  <Box p={0} flexGrow={1}>
                    <Select
                      options={_consequences}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={handleChangeConsequence}
                      defaultValue={_selectedConsequenceEid}
                      isDisabled={_consequenceDisabled}
                      placeholder={
                        getUseAutoConsequence(_selectedScoreCategoryId) === "Y"
                          ? "(calculated)"
                          : "(select)"
                      }
                    />
                  </Box>
                  <Box pl={1} flexGrow={0}>
                    <Button
                      variant="contained"
                      onClick={handleClickViewAutoConsequences}
                      disabled={!_consequenceDisabled}
                    >
                      View
                    </Button>
                  </Box>
                </Box>
              </Grid>
            )}
          </>
        )}
      </Grid>
      <Grid container spacing={1} sx={{ mt: 0.0 }}>
        <Grid item xs={4}>
          <InputLabel>Date *</InputLabel>
          <MobileDatePicker
            slotProps={{ textField: { size: "small" } }}
            value={_scoreDate}
            onChange={(newValue) => {
              setScoreDate(newValue);
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <InputLabel>
            Period
            {school["consequenceMode"] === 1 && <> (optional)</>}
            {school["consequenceMode"] === 2 && <> *</>}
          </InputLabel>
          <Select
            options={_scorePeriods}
            onChange={handleChangeScorePeriod}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <InputLabel>Comment (optional)</InputLabel>
          <TextField
            margin="dense"
            type="text"
            size="small"
            fullWidth
            variant="outlined"
            onChange={handleChangeComment}
            placeholder="Optional"
            value={_comment}
            sx={{ mt: 0 }}
          />
        </Grid>
      </Grid>
    </>
  );

  return (
    <>
      {_selectedScoreGroup === "S" && (
        <>
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Grid
                  item
                  xs={10}
                  sx={{
                    fontSize: "1.25em",
                    fontWeight: "bold",
                    color: "#696969",
                    marginBottom: 1,
                  }}
                >
                  Scoring
                </Grid>
                <Grid item xs={2}>
                  <ProgressCircle showProgress={showProgress} />
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {_scoreCategories.map((cat) => (
                  <>
                    {cat.isQuick === "Y" && (
                      <Button
                        key={cat.id}
                        sx={{
                          minHeight: 36,
                          backgroundColor: "#42a5f5",
                          "&:hover": {
                            backgroundColor: "#256bb3",
                          },
                        }}
                        variant="contained"
                        title={`quick ${cat.name.toLowerCase()}`}
                        onClick={() => handleClickQuickCategory(cat)}
                        startIcon={<TimerIcon style={{ fill: "#ffffff" }} />}
                      >
                        {cat.shortName}
                      </Button>
                    )}
                  </>
                ))}
                <Button
                  variant="outlined"
                  onClick={handleClickTardyKiosk}
                  title="Tardy Kiosk"
                >
                  Tardy Kiosk
                </Button>
                {school.qrEnabled === "Y" && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClickTardyQrCode}
                    title="Tardy QR Code"
                  >
                    {isMobile === true && "QR"}
                    {isMobile === false && "Tardy QR"}
                  </Button>
                )}
                {isDetailedView && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleOpenDetailedScoreDialog}
                  >
                    Detailed Score
                  </Button>
                )}
              </Box>
              <br />
            </Grid>
            {isMobile === false && _myStudentScores.length > 0 && (
              <Grid item xs={12}>
                <Divider />

                <HeaderText text={`My Students (${_myStudentScores.length})`} />

                <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
                  <Table aria-label="my students" size="small">
                    <TableHead>
                      <StripedTableRow>
                        <StripedTableCell>Time</StripedTableCell>
                        <StripedTableCell>Student</StripedTableCell>
                        <StripedTableCell>Type</StripedTableCell>
                        <StripedTableCell>From</StripedTableCell>
                        <StripedTableCell>Consequence</StripedTableCell>
                      </StripedTableRow>
                    </TableHead>
                    <TableBody>
                      <TableRowNoResults data={_myStudentScores} />
                      {_myStudentScores.map((a) => (
                        <StripedTableRow key={a.studentEid}>
                          <StripedTableCell>
                            {dayjs(a.dateCreated).format("HH:mm")}
                          </StripedTableCell>
                          <StripedTableCell>
                            {a.last_name}, {a.first_name} ({a.grade})
                          </StripedTableCell>
                          <StripedTableCell>{a.categoryName}</StripedTableCell>
                          <StripedTableCell>
                            {a.teacherLastName}
                          </StripedTableCell>
                          <StripedTableCell>{a.conName}</StripedTableCell>
                        </StripedTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
          <Link target="_blank" href={_receiptUrl} id="rl" />
        </>
      )}

      <SelectStudentListsDialog
        open={_dialogStudentListsOpen}
        onClose={handleStudentListClose}
        onOK={handleStudentListOK}
        studentLists={_userLists}
      />
      <Dialog
        PaperProps={{
          sx: {
            width: isMobile === true ? 400 : 900,
            maxHeight: isMobile === true ? 400 : 450,
          },
        }}
        onClose={handleCloseDetailedScoreDialog}
        open={_dialogDetailedScoreOpen}
        fullScreen={true}
      >
        <DialogTitle>Create Detailed Score</DialogTitle>
        <DialogContent>{renderDetailedScoreContent()}</DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseDetailedScoreDialog}>
            Close
          </Button>
          {showPrintReceipt && (
            <Button
              sx={{ ml: 1 }}
              variant="contained"
              onClick={handleClickSavePrintReceipt}
              className="button1"
              disabled={showProgress === true}
            >
              Save+Print Receipt
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleClickSave}
            disabled={showProgress === true}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={handleCloseConsequenceList}
        open={_dialogConsequenceListOpen}
        fullScreen={true}
      >
        <DialogTitle id="select-student-list-dialog-title">
          Calculated Consequences
        </DialogTitle>

        <DialogContent>
          <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
            <Table aria-label="student scores" size="small">
              <TableHead>
                <StripedTableRow>
                  <StripedTableCell>Student</StripedTableCell>
                  <StripedTableCell>Consequence</StripedTableCell>
                </StripedTableRow>
              </TableHead>
              <TableBody>
                <TableRowNoResults data={_calculatedConsequences} />
                {_calculatedConsequences.map((a) => (
                  <StripedTableRow key={a.studentEid}>
                    <StripedTableCell>
                      {a.lastName}, {a.firstName}
                    </StripedTableCell>
                    <StripedTableCell>
                      {a.value} - {a.consequenceName}
                    </StripedTableCell>
                  </StripedTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseConsequenceList}>CLOSE</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            width: isMobile === true ? 400 : 600,
            maxHeight: isMobile === true ? 400 : 600,
          },
        }}
        onClose={handleClosePreviousScores}
        open={_dialogPreviousScoresOpen}
        fullScreen={true}
      >
        <DialogTitle>Previous Scores</DialogTitle>

        <DialogContent>
          <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
            <Table aria-label="previous scores" size="small">
              <TableHead>
                <StripedTableRow>
                  <StripedTableCell>Date</StripedTableCell>
                  <StripedTableCell>Student</StripedTableCell>
                  <StripedTableCell>Score</StripedTableCell>
                </StripedTableRow>
              </TableHead>
              <TableBody>
                <TableRowNoResults data={_previousScores} />
                {_previousScores.map((a) => (
                  <StripedTableRow key={a.studentEid}>
                    <StripedTableCell>
                      {dayjs(a.scoreDate).format("MM/DD")}
                    </StripedTableCell>
                    <StripedTableCell>
                      {a.last_name}, {a.first_name}
                    </StripedTableCell>
                    <StripedTableCell>
                      <b>{a.categoryName}</b>
                      <br />
                      {a.scoreValue} - {a.conName}
                    </StripedTableCell>
                  </StripedTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClosePreviousScores}>CLOSE</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperProps={{
          sx: {
            width: isMobile === true ? 300 : 600,
            maxHeight: isMobile === true ? 400 : 600,
            position: "fixed",
            top: isMobile === true ? "0px" : "100px",
            left: isMobile === true ? "0px" : "100px",
          },
        }}
        open={_dialogQuickOpen}
        disableBackdropClick
      >
        <DialogTitle>Quick {_selectedScoreCategory.name}</DialogTitle>

        <DialogContent>
          <Alert severity="info">
            Select one or more students below to quickly create{" "}
            {_selectedScoreCategory.name} entries for them.
          </Alert>

          <InputLabel sx={{ mt: 0 }}>Select 1 or more Students *</InputLabel>
          <Select
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            options={_students}
            onChange={handleChangeQuickStudents}
            value={_selectedQuickStudents}
            isMulti={true}
          />

          {_selectedScoreCategory.typeCode === "P" &&
            _selectedScoreCategory.reasons &&
            _selectedScoreCategory.reasons.length > 0 && (
              <>
                <InputLabel sx={{ mt: 1 }}>Reason for Score *</InputLabel>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  options={_selectedScoreCategory.reasons}
                  onChange={handleChangeQuickReason}
                  value={_selectedReasonObj}
                  isMulti={false}
                />
              </>
            )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleCloseQuick}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleOKQuick}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddQuickScore;
